import { render, staticRenderFns } from "./CreateMultiple.vue?vue&type=template&id=847fe8c2&"
import script from "./CreateMultiple.vue?vue&type=script&lang=js&"
export * from "./CreateMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateMultiple.vue"
export default component.exports